import type { WebsiteHeaderPhotoSchema_VideoBackground_v1_1_1 } from '@shared/types/WebsiteHeaderSettings.types';

export const VIDEO_BACKGROUND_v1_1_1: WebsiteHeaderPhotoSchema_VideoBackground_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackground-v1_1_1.json',
  presentationLayout: 'videoBackground',
  video: undefined,
  eventName: undefined,
  colors: undefined,
};
